module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "waveStatusModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS000))])]), _vm._v(" "), (_vm.elementId) ? _c('label', {
    staticClass: "control-label nopadding"
  }, [_vm._v("ID: " + _vm._s(_vm.elementId))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "wave-status-modal-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(
    _vm.statusData.SurveyInstances &&
    _vm.statusData.SurveyInstances.Status
  ) ? _c('tr', [_c('td', {
    staticClass: "text-left noborder"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS001))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left noborder"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS002))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.SurveyInstances.Status.Count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS003))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Approval) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS004))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.InProgress) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS005))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Reporting) + "\n                        ")])]), _vm._v(" "), (_vm.statusData.Wave) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS006))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((_vm.statusData.Wave.InTime * 100).toFixed(2))) + "\n                          %\n                        ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Approvals) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS007))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS008))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.WithoutProposals))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS009))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.WithProposals))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS010))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.Approved))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS011))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.Rejected))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS012))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WVS013))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS014))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS015))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS018))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WVS013))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS014))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS015))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CompetitorCarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.WVS016) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95799446","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/WaveStatusModal.vue
// module id = 646
// module chunks = 1 2